import { IRestfulConfigMap } from "@core/data-access/restful";
import { envConfig } from "@env/env-config";
let PropertyFormRestConfig: IRestfulConfigMap = {
    "propertyFormRestService": {
        appPath: envConfig.appPath("base"),
        isAuth: true,
        actions: {
            getUrl: {
                method: "get",
                path: "api/product/:productId/form/:formCode/url/latest",
                paramDefaults: {
                    productId: "@productId",
                    formCode: "@formCode",
                    version: "@version",
                    versionedAttributeId:"@versionedAttributeId"
                }
            }
        }
    }
}
export { PropertyFormRestConfig };